import { VatCodeDtoToEntity } from "src/app/features/VatCode/services/mappers/VatCodeDtoToEntity";
import type { VatCodeDto } from "src/app/features/VatCode/types/VatCodeDto";
import type { VatCodeEntity } from "src/app/features/VatCode/types/VatCodeEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const VatCodeTableDtoMapper = (input: Readonly<ResourcePageDto<VatCodeDto>>): ResourcePageEntity<VatCodeEntity> => {
    return {
        list: input.list ? input.list.map(VatCodeDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
